export default __webpack_public_path__ + "static/AX-logo-WBC-OS-RGB-008a59d16f2e1d47a762ac55efae6da3.png";